export const GIPHY_API_KEY = 'VABrFK9YpxloUry2uKwho4urtzOcHv2V';

export const AVATAR_INITIALS = 'https://ui-avatars.com/api';

export const BE_INTEGRATION = 'https://pager-hiring.herokuapp.com';

export const GIPHY_BASE_URL = 'https://api.giphy.com/v1/gifs/random';

export const SERVER_EVENTS = {
  IS_TYPING: 'is-typing',
  MESSAGE: 'message',
  USER_CONNECTED: 'user-connected',
  USER_DISCONNECTED: 'user-disconnected'
};

export const CLIENT_EVENTS = {
  IMAGE_MESSAGE: 'image-message',
  TEXT_MESSAGE: 'text-message',
  TYPING: 'typing'
};
